import {
  Autocomplete,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import html2pdf from "html2pdf.js";

const Part4 = () => {
  const [inputStates, setInputStates] = useState({
    columnType: 3,
    siRate: 0,
    percentSIR: 0,
  });

  const [circlesData, setCirclesData] = useState([]);
  const [allLOTData, setAllLOTData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [totalRows, setTotalRows] = React.useState(0);
  const [finalData, setFinalData] = React.useState([]);
  const [mergedData, setMergedData] = React.useState([]);

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    // if (_userType == 3)
    //   whereConditions +=
    //     whereConditions.length > 0
    //       ? `and cert.clientId = ${_clientId}`
    //       : `and cert.clientId = ${_clientId}`;
    // whereConditions +=
    //   whereConditions.length > 0
    //     ? " AND cert.status = 1"
    //     : "AND cert.status = 1";

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

    let data = {
      query: `SELECT le.*, tcl.circleId,tcl.oilSuppliedBy, tt.transformerCapacity, tt.kva, tt.wound, p.name FROM lotEstimated le LEFT JOIN transactionControlLots tcl ON le.lotId = tcl.id LEFT JOIN transformerTypes tt ON le.capacityId = tt.id LEFT JOIN parts p ON le.partId = p.id WHERE le.lotId = ${inputStates?.LotId} AND le.jobNo BETWEEN ${inputStates?.fromJobNo} AND ${inputStates?.toJobNo} ${whereConditions}   `,
    };

    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows FROM lotEstimated le LEFT JOIN transactionControlLots tcl ON le.lotId = tcl.id LEFT JOIN transformerTypes tt ON le.capacityId = tt.id LEFT JOIN parts p ON le.partId = p.id WHERE le.lotId = ${inputStates?.LotId} AND le.jobNo BETWEEN ${inputStates?.fromJobNo} AND ${inputStates?.toJobNo}  ${whereConditions}`;
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
      });
  }

  function fetchFinalData() {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  }

  // General handler to update state for both TextField and Autocomplete
  const handleLotsChange = (key, value) => {
    setInputStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const fetchCirclesData = () => {
    let SQLQuery = { query: `select id, name  from circles where alloted = 1` };

    axiosWithToken
      .post(BASE_URL + `dynamic`, SQLQuery)
      .then((res) => {
        setCirclesData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  };

  const fetchAllLOTData = () => {
    let SQLQuery = {
      query: `SELECT tcl.id, tcl.circleId, tcl.lotNo, tcl.mostTransformersCapacity, tt.storeIssueRate, tt.id as transformerTypesId,  tt.transformerCapacity FROM transactionControlLots tcl LEFT JOIN transformerTypes tt ON CAST(tcl.mostTransformersCapacity AS UNSIGNED) = tt.id WHERE tcl.circleId = ${inputStates?.circleId}`,
    };

    axiosWithToken
      .post(BASE_URL + `dynamic`, SQLQuery)
      .then((res) => {
        setAllLOTData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  };

  function mergeDataByLotIdAndJobNo(data) {
    const resultArray = [];

    // Add the new common keys: 'kva', 'capacityId', 'wound'
    const commonKeys = [
      "lotId",
      "jobNo",
      "make",
      "siNo",
      "mfgYear",
      "repairNo",
      "economicReason",
      "kva",
      "capacityId",
      "wound",
      "oilSuppliedBy",
    ];

    data.forEach((item) => {
      // Check if an object with the same lotId and jobNo already exists
      const existingEntry = resultArray.find(
        (entry) => entry.lotId === item.lotId && entry.jobNo === item.jobNo
      );

      if (!existingEntry) {
        // If no existing entry is found, create a new object for this lotId and jobNo
        const newObject = {};

        // Copy over common keys and their values
        commonKeys.forEach((key) => {
          if (item[key] !== undefined) {
            newObject[key] = item[key];
          }
        });

        // Add other keys with partId appended
        Object.keys(item).forEach((itemKey) => {
          if (!commonKeys.includes(itemKey) && itemKey !== "partId") {
            const newKey = `${itemKey}_${item.partId}`;
            newObject[newKey] = item[itemKey];
          }
        });

        resultArray.push(newObject);
      } else {
        // If an existing entry is found, just append new key-value pairs for this partId
        Object.keys(item).forEach((itemKey) => {
          if (!commonKeys.includes(itemKey) && itemKey !== "partId") {
            const newKey = `${itemKey}_${item.partId}`;
            existingEntry[newKey] = item[itemKey];
          }
        });
      }
    });

    return resultArray;
  }

  const PDFHeader = () => (
    <div style={{ width: "100%", margin: "0 auto", paddingBottom: "10px" }}>
      <div
        style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
      >
        INSPECTION REPORT & ESTIMATES (IN NUTSHELL) FOR REPAIR OF TRANSFORMER
        UNDER CRC T.N.1847
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "16px",
          marginTop: "4px",
        }}
      >
        <div>
          <strong>Firm:</strong>{" "}
          <strong style={{ fontSize: "18px", fontWeight: "bold" }}>
            CHETANI ELECTRICAL EQUIPMENTS
          </strong>
          <br />
          E-227, Road No. 9E, V K I Area, Jaipur-302013(Raj)
          <br />
          Rate Contract No.
          AVVNL/SE(MM)/E2A8/TN-1847/S.No.3/R.C.No.13468/D.17388 Dated 14 MAR
          2024
        </div>
        <div style={{ textAlign: "right" }}>
          Part 4/4
          <br />
          <strong>GSTIN:</strong> 08ABLPC1952D1ZZ
          <br />
          <strong>PAN:</strong> ABLPC1952D
          <br />
          Transformer received from: CHETANI ELECTRICAL EQUIPMENTS
          <br />
          <strong>Lot No.:</strong>{" "}
          {allLOTData?.find((ele) => ele.id == inputStates.LotId)?.lotNo}
          <br />
          <strong>Date:</strong> {new Date().toLocaleDateString("en-GB")}
        </div>
      </div>
    </div>
  );

  const addFooter = (pdf, pageWidth, pageHeight) => {
    const topRow = [
      "DHARMANDRA SAINI",
      "MOHD. MANJAR ILMI",
      "( )",
      "T A to S E (O&M)",
      "A O (O&M)",
      "S E (O&M)",
    ];

    const bottomRow = [
      "AEN(O&M), AVVNL, FATEHPUR",
      "AEN(O&M), AVVNL, KUDAA",
      "CHETANI ELECTRICAL EQUIPMENTS",
      "AVVNL, SIKAR",
      "A.E.N., AVVNL, SIKAR",
      "AVVNL, SIKAR",
    ];

    const footerWidth = pageWidth * 0.9;
    const startX = (pageWidth - footerWidth) / 2;
    const colWidth = footerWidth / topRow.length;

    const baseY = pageHeight - 0.5; // Bottom margin (adjust as needed)
    const rowGap = 0.28; // Vertical gap between top and bottom row

    topRow.forEach((topText, index) => {
      const bottomText = bottomRow[index];
      const centerX = startX + colWidth * index + colWidth / 2;

      // Bottom row text
      pdf.setFontSize(8);
      pdf.setFont("helvetica", "normal");
      pdf.text(bottomText, centerX, baseY, { align: "center" });

      // Top row text above it, centered vertically
      pdf.setFontSize(9);
      pdf.setFont("helvetica", "bold");
      pdf.text(topText, centerX, baseY - rowGap, { align: "center" });
    });
  };

  const downloadPDF = () => {
    const element = document.getElementById("table-to-pdf");

    // Add temporary class for styling if needed
    element.classList.add("pdf-export-mode");

    const opt = {
      margin: [0.5, 0.5, 0.5, 0.5], // top, left, bottom, right (in inches)
      filename: "part4.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 4,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "landscape",
      },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        const totalPages = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          addFooter(pdf, pageWidth, pageHeight);
        }
      })
      .save()
      .then(() => {
        element.classList.remove("pdf-export-mode");
      });
  };

  useEffect(() => {
    const mergedData = mergeDataByLotIdAndJobNo(finalData);
    setMergedData(mergedData);
    console.log("mergedData", mergedData);
  }, [finalData]);

  useEffect(() => {
    fetchCirclesData();
  }, []);

  useEffect(() => {
    if (inputStates?.circleId) fetchAllLOTData();
  }, [inputStates?.circleId]);

  return (
    <div>
      <div
        style={{
          border: "1px solid gray",
          width: "100%",
          margin: "auto",
          backgroundColor: "#f5f1f1",
          //   marginTop: "4px",
          display: "flex",
          padding: "6px",
          flexWrap: "wrap",
          justifyContent: "space-between",
          margin: "auto",
        }}
      >
        {/* First Row */}
        <div
          style={{
            display: "flex",
            width: "80%",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <h6 style={{ fontSize: "13px", margin: 0 }}>Circle Name</h6>
          <Autocomplete
            key={inputStates.circleId}
            options={circlesData}
            value={
              circlesData?.find((ele) => ele.id == inputStates.circleId) || null
            }
            getOptionLabel={(option) => option.name}
            onChange={(event, value) => handleLotsChange("circleId", value?.id)}
            renderInput={(params) => (
              <TextField
                {...params}
                label=""
                fullWidth
                size="small"
                sx={{
                  "& .MuiInputBase-input": { fontSize: "13px" }, // Font size for input text
                }}
                InputProps={{
                  ...params.InputProps,
                  style: { height: 30, fontSize: "13px" }, // Font size for input field
                }}
              />
            )}
            sx={{
              "& .MuiAutocomplete-option": {
                fontSize: "13px", // Font size for options
              },
            }}
            style={{ minWidth: "200px" }}
          />

          <h6 style={{ fontSize: "13px", marginLeft: "10px", margin: 0 }}>
            Lot No
          </h6>

          <Autocomplete
            key={inputStates.LotId}
            options={allLOTData || []}
            value={
              allLOTData?.find((ele) => ele.id == inputStates.LotId) || null
            }
            getOptionLabel={(option) => option.lotNo}
            // onChange={(event, value) => handleLotsChange("LotId", value?.id)}
            onChange={(event, value) => {
              setInputStates((prevState) => ({
                ...prevState,
                LotId: value.id,
                capacityId: value.mostTransformersCapacity,
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label=""
                fullWidth
                size="small"
                sx={{
                  "& .MuiInputBase-input": { fontSize: "13px" },
                }}
                InputProps={{
                  ...params.InputProps,
                  style: { height: 30, fontSize: "13px" },
                }}
              />
            )}
            sx={{
              "& .MuiAutocomplete-option": {
                fontSize: "13px", // Font size for options
              },
            }}
            style={{ minWidth: "100px" }}
          />

          <h6 style={{ fontSize: "13px", margin: 0 }}> From Job No.</h6>
          <TextField
            name="fromJobNo"
            size="small"
            variant="outlined"
            value={inputStates.fromJobNo}
            onChange={(e) => handleLotsChange("fromJobNo", e.target.value)}
            style={{ width: "60px", height: 30, fontSize: "13px" }}
            InputProps={{
              style: { height: 30, fontSize: "13px" },
            }}
          />

          <h6 style={{ fontSize: "13px", margin: 0 }}> To Job No.</h6>
          <TextField
            name="toJobNo"
            size="small"
            variant="outlined"
            value={inputStates.toJobNo}
            onChange={(e) => handleLotsChange("toJobNo", e.target.value)}
            style={{ width: "60px", height: 30, fontSize: "13px" }}
            InputProps={{
              style: { height: 30, fontSize: "13px" },
            }}
          />

          <Button
            variant="contained"
            onClick={() => {
              fetchFinalData();
              getTotalRows();
            }}
            style={{
              marginLeft: "10px",
              //   height: "30px",
              fontSize: "10px",
              padding: "5px 10px",
            }}
          >
            Prepare Data
          </Button>

          <Button
            variant="contained"
            onClick={downloadPDF}
            style={{
              marginLeft: "10px",
              //   height: "30px",
              fontSize: "10px",
              padding: "5px 10px",
            }}
          >
            Download PDF
          </Button>
        </div>
      </div>

      <br />

      <TableContainer
        component={Paper}
        className="tableContainer"
        id="table-to-pdf"
      >
        <div style={{ textAlign: "left", marginLeft: "50px" }}>
          <PDFHeader />
        </div>
        <Table className="table">
          <TableHead>
            <TableRow>
              <TableCell rowSpan={3} className="headerCell">
                S. No
              </TableCell>
              <TableCell rowSpan={3} className="headerCell">
                Job No.
              </TableCell>
              <TableCell rowSpan={3} className="headerCell">
                Net Cost of repair after deducting salvage (54-69)
              </TableCell>
              <TableCell rowSpan={3} className="headerCell">
                Deduct cost of New Tr oil if supplied by Nigam
              </TableCell>
              <TableCell rowSpan={3} className="headerCell">
                Net Amount excluding cost of M & P Unit & Labour thereof(69-70)
              </TableCell>
              <TableCell colSpan={12} className="headerCell">
                Supply and fixing of M & P Unit
              </TableCell>
              <TableCell rowSpan={3} className="headerCell">
                Amount payable to the contractor (70+84)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell rowSpan={1} colSpan={7} className="headerCell">
                Cost of M & P Unit
              </TableCell>
              <TableCell rowSpan={1} colSpan={4} className="headerCell">
                Fixing Charges of M & P Unit
              </TableCell>
              <TableCell rowSpan={2} colSpan={1} className="headerCell">
                Total (79 + 83)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="headerCell">MS</TableCell>
              <TableCell className="headerCell">DM</TableCell>
              <TableCell className="headerCell">Rate</TableCell>
              <TableCell className="headerCell">Amount</TableCell>
              <TableCell className="headerCell">C GST</TableCell>
              <TableCell className="headerCell">S GST</TableCell>
              <TableCell className="headerCell">Total</TableCell>
              <TableCell className="headerCell">Amount</TableCell>
              <TableCell className="headerCell">C GST</TableCell>
              <TableCell className="headerCell">S GST </TableCell>
              <TableCell className="headerCell">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className="bodyCell">1</TableCell>
              <TableCell className="bodyCell">2</TableCell>
              {[...Array(16)].map((_, i) => (
                <TableCell key={i + 2} className="bodyCell">
                  {70 + i}
                </TableCell>
              ))}
            </TableRow>

            {mergedData?.map((ele, index) => {
              const total = (
                (ele.amount_20 || 0) +
                (ele.amount_21 || 0) +
                (ele.amount_22 || 0)
              ).toFixed(2);

              const newCgst = (total * 0.09).toFixed(2);
              const newSgst = (total * 0.09).toFixed(2);
              const finalSum = (
                parseFloat(total) +
                parseFloat(newCgst) +
                parseFloat(newSgst)
              ).toFixed(2);

              const total1 =
                ele.amount_8 +
                ele.amount_9 +
                ele.amount_10 +
                ele.amount_11 +
                ele.amount_12 +
                ele.amount_13;
              const finalSum1 = total1 + total1 * 0.09 * 2;

              const grandTotal = (
                finalSum1 +
                ele.cgst_7 +
                ele.sgst_7 +
                ele.amount_7 +
                ele.cgst_5 +
                ele.cgst_6 +
                ele.sgst_5 +
                ele.sgst_6 +
                ele.amount_5 +
                ele.amount_6
              ).toFixed(2);

              const totalSlvgAmount = (
                ele.salvageAmount_5 +
                ele.salvageAmount_6 +
                ele.salvageAmount_10 +
                ele.salvageAmount_11
              ).toFixed(2);

              const slvgCgst = (totalSlvgAmount * 0.09).toFixed(2);
              const slvgSgst = (totalSlvgAmount * 0.09).toFixed(2);

              const totalSlvgAmountWithGst = (
                parseFloat(totalSlvgAmount) +
                parseFloat(slvgCgst) +
                parseFloat(slvgSgst)
              ).toFixed(2);
              return (
                <>
                  <TableRow>
                    <TableCell className="bodyCell">{index + 1}</TableCell>
                    <TableCell className="bodyCell">{ele.jobNo}</TableCell>
                    <TableCell className="bodyCell">
                      {(
                        parseFloat(finalSum) +
                        parseFloat(grandTotal) -
                        parseFloat(totalSlvgAmountWithGst)
                      ).toFixed(2)}
                    </TableCell>

                    <TableCell className="bodyCell">
                                        {ele.oilSuppliedBy === 2
                                          ? (ele.cgst_7 + ele.sgst_7 + ele.amount_7).toFixed(2)
                                          : ""}
                                      </TableCell>
                    <TableCell className="bodyCell">
                      {(
                        parseFloat(finalSum) +
                        parseFloat(grandTotal) -
                        parseFloat(totalSlvgAmountWithGst) -
                        parseFloat(
                          (ele.cgst_7 + ele.sgst_7 + ele.amount_7).toFixed(2)
                        )
                      ).toFixed(2)}
                    </TableCell>

                    <TableCell className="bodyCell">{ele.missing_4}</TableCell>
                    <TableCell className="bodyCell">{ele.damaged_4}</TableCell>
                    <TableCell className="bodyCell">{ele.rate_4}</TableCell>
                    <TableCell className="bodyCell">{ele.amount_4}</TableCell>
                    <TableCell className="bodyCell">{ele.cgst_4}</TableCell>
                    <TableCell className="bodyCell">{ele.sgst_4}</TableCell>
                    <TableCell className="bodyCell">{ele.total_4}</TableCell>

                    <TableCell className="bodyCell">{ele.amount_25}</TableCell>
                    <TableCell className="bodyCell">{ele.cgst_25}</TableCell>
                    <TableCell className="bodyCell">{ele.sgst_25}</TableCell>
                    <TableCell className="bodyCell">{ele.total_25}</TableCell>

                    <TableCell className="bodyCell">
                      {(ele.total_25 + ele.total_4).toFixed(2)}
                    </TableCell>
                    <TableCell className="bodyCell">
                      {(
                        ele.total_25 +
                        ele.total_4 +
                        (parseFloat(finalSum) +
                          parseFloat(grandTotal) -
                          parseFloat(totalSlvgAmountWithGst))
                      ).toFixed(2)}
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>

        {/* CSS for the table */}
        <style>
          {`
          .tableContainer {
            padding: 20px;
            max-width: 100%;
            overflow-x: auto;
             fontSize:8px;
          }

          .table {
            width: 100%;
            border-collapse: collapse;
             fontSize:8px;
          }

          .headerCell {
            border: 1px solid black;
            padding: 2px;
            text-align: center;
            background-color: #f2f2f2;
            font-weight: bold;
              fontSize:8px;
          }

          .bodyCell {
            border: 1px solid black;
            padding: 2px;
            text-align: center;
            fontSize:8px;
          }

            .pdf-export-mode {
            transform: scale(0.97);
            transform-origin: top left;
            width: max-content;
          }
        `}
        </style>
      </TableContainer>
    </div>
  );
};

export default Part4;
